class L.MfMarkerClusterGroup extends L.MarkerClusterGroup

    _defaultIconCreateFunction: (cluster) ->
        childCount = cluster.getChildCount()

        c = ' marker-cluster-'
        if (childCount < 10)
            c += 'small'
        else if (childCount < 100)
            c += 'medium'
        else
            c += 'large'

        return new L.DivIcon({
            html: '
                <div class="hex-outer">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="hex-inner">
                    <div class="hex-left"></div>
                    <div class="hex-middle"></div>
                    <div class="hex-right"></div>
                </div>
                <div class="count-text">
                    ' + childCount + '
                </div>
            ',
            className: 'marker-cluster' + c
            iconSize: new L.Point(44, 44)
        })
